import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, ChevronDown } from 'lucide-react';

function CondoSwitcher({ condos, currentSlug, tab }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const tabPath = tab ? `/${tab}` : '';

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="menu"
        className="flex items-center gap-1 px-2 py-1 rounded-lg border border-border text-xs text-muted-foreground hover:text-foreground hover:bg-muted transition-colors whitespace-nowrap"
      >
        Switch condo <ChevronDown className="h-4 w-4" />
      </button>
      {open && (
        <div role="menu" className="absolute left-0 mt-2 w-64 bg-card border border-border rounded-lg shadow-lg py-1 z-50">
          {condos.map((c) => (
            <Link
              key={c._id}
              role="menuitem"
              to={`/admin/${c.slug}${tabPath}`}
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-2 px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors"
            >
              <span className="truncate">{c.name}</span>
              {c.slug === currentSlug && <Check className="h-4 w-4 text-primary shrink-0" />}
            </Link>
          ))}
          <div className="border-t border-border mt-1 pt-1">
            <Link
              role="menuitem"
              to="/admin"
              onClick={() => setOpen(false)}
              className="block px-4 py-2 text-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
            >
              All condos
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default CondoSwitcher;
